export type SizeStylesDictionary<Size extends number, ValueType> =
	Partial<{ [size in Size]: ValueType }>

/**
 * Picks style from styles dictionary according to size value.
 * @param size current size.
 * @param styles dictionary size - style value
 * @returns resolved value from dictionary.
 */
export const getStyleBySize = <Size extends number, ValueType>(size: number, styles: SizeStylesDictionary<Size, ValueType>): ValueType =>
	Object.keys(styles)
		.map(Number)
		.sort()
		.map(key => ({ key, style: styles[key] }))
		.reduce((result, rule) => size >= rule.key ? rule.style : result, undefined);
